import { Interceptor } from '@connectrpc/connect';

export const PlatformIdInterceptor: Interceptor = (next) => async (req) => {
  req.header.set('platform-id', '0');
  return next(req);
};
